var render = function render(){var _vm=this,_c=_vm._self._c;return _c('field',{attrs:{"margin":"0","padding":"0","is-off-style":"","dateValue":_vm.filterDate,"is-time":"","isOnlyMonthAndYear":""},on:{"updateTime":function($event){return _vm.onTime($event)},"updateToday":_vm.onToday}})
}
var staticRenderFns = []

export { render, staticRenderFns }